import $ from 'jquery';

import { FireComponent, FireHelpers } from '@base';

export class SidebarNav extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {
      $callout: this.$component.find('[data-sidebar-callout]'),
      $callouts: this.$component.find('[data-sidebar-callouts]'),
    };
  }

  _toggleDesktop() {
    // open sidebar nav on page load
    $('#bux-sidebar-nav').removeClass('disclosure-nav-closed').addClass('disclosure-nav-open');

    // create untabbable sidebar nav toggle
    $('.bux-sidebar-page #bux-sidebar-nav > ul > [data-sidebar-nav-item-active] > a').each(function (index, element) {
      var title = $(element).text().trim();

      $('[data-sidebar-nav-toggle]').empty().attr('tabindex', '-1');
      $('[data-sidebar-nav-title]').empty().append(title);
    });
  }

  _toggleMobile() {
    // close sidebar nav on page load
    var closeSidenavOnLoad = setInterval(function () {
      if ($('#bux-sidebar-nav').hasClass('disclosure-nav')) {
        clearInterval(closeSidenavOnLoad);

        $('#bux-sidebar-nav').removeClass('disclosure-nav-open').addClass('disclosure-nav-closed');
      }
    }, 100);

    // add sidebar nav toggle button
    $('.bux-sidebar-page #bux-sidebar-nav > ul > [data-sidebar-nav-item-active] > a').each(function (index, element) {
      var title = $(element).text().trim();

      $('[data-sidebar-nav-toggle]').empty().attr('tabindex', '0');
      $('[data-sidebar-nav-toggle]').append('<span aria-hidden="true" data-sidebar-nav-toggle-bars></span><span aria-label="Toggle ' + title + ' menu" data-sidebar-nav-title>' + title + '</span>');
    });

    // toggle sidebar nav visibility
    $('[data-sidebar-nav-toggle]')
      .unbind()
      .on('click', function () {
        if ($('#bux-sidebar-nav').hasClass('disclosure-nav-closed')) {
          $('#bux-sidebar-nav').removeClass('disclosure-nav-closed').addClass('disclosure-nav-open');
        } else {
          $('#bux-sidebar-nav').removeClass('disclosure-nav-open').addClass('disclosure-nav-closed');
        }
      });
  }

  _active() {
    // remove all sidebar nav items that aren't active
    $('.bux-sidebar-page #bux-sidebar-nav > ul > [data-sidebar-nav-item]').each(function (index, element) {
      if (!$(element).is('[data-sidebar-nav-item-active]')) {
        $(element).remove();
      }
    });

    // expand active sidebar nav tree
    var activeSideNavExpand = setInterval(function () {
      if ($('#bux-sidebar-nav').hasClass('disclosure-nav')) {
        clearInterval(activeSideNavExpand);

        $('[data-sidebar-nav-item-active]').each(function (index, element) {
          $(element).children('button').attr('aria-expanded', 'true');
          $(element).children('ul').removeClass('disclosure-nav-submenu-closed').addClass('disclosure-nav-submenu-open');
        });
      }
    }, 100);
  }

  _calloutsDesktop() {
    // append callouts
    if ($('[data-sidebar-callout]').length) {
      $('[data-sidebar-callout]').each(function (index, element) {
        $(element).appendTo('[data-sidebar-callouts]');
      });
    }
  }

  _calloutsMobile() {
    // append callouts
    if ($('[data-sidebar-callout]').length) {
      $('[data-sidebar-callout]').each(function (index, element) {
        $(element).appendTo('[data-sidebar-callouts-mobile]');
      });
    }
  }

  _ada() {
    var ada = setInterval(function () {
      if ($('#bux-sidebar-nav').hasClass('disclosure-nav')) {
        clearInterval(ada);

        // reset aria attrs
        $('[data-sidebar-nav-item-active]').each(function (index, element) {
          $(element).children('button, a').attr('aria-expanded', 'true');
          $(element).children('ul').removeClass('disclosure-nav-menu-closed').addClass('disclosure-nav-menu-open');
        });

        // make subnav tabbable when open
        $('.bux-container--sidebar-nav > nav > ul > li > ul > li.bux-sidebar-nav__item').each(function (index, element) {
          $(element).children('button, a').attr('tabindex', '0');
        });

        // make sidebar nav items tabbable
        $('.bux-sidebar-page #bux-sidebar-nav > ul > [data-sidebar-nav-item] > ul > li > a').each(function (index, element) {
          $(element).attr('tabindex', '0');
          $(element).siblings('ul').find('a').attr('tabindex', '0');
          $(element).siblings('button.disclosure-nav-submenu-toggle').attr('tabindex', '0');
        });
      }
    }, 100);
  }

  init() {
    if (this.componentExists) {
      this._active();
      this._ada();

      if (window.innerWidth >= FireHelpers.breakpoints.xl) {
        this._toggleDesktop();
        this._calloutsDesktop();
      } else {
        this._toggleMobile();
        this._calloutsMobile();
      }

      $(window).on('resize', () => {
        if (window.innerWidth >= FireHelpers.breakpoints.xl) {
          this._toggleDesktop();
          this._calloutsDesktop();
        } else {
          this._toggleMobile();
          this._calloutsMobile();
        }
      });
    }
  }
}
